<template>
    <div class="head_page">
        <div class="contentWidth ly_flex ly_flex_ali_center ly_flex_just_between">
            <img class="logo" src="../../../assets/img/logo.png" alt="">
            <!--导航 start-->
            <ul class="ly_flex">
                <li :class="['nav_class',{'select_class':headIndex === index}]"
                    v-for="(item,index) in navList"
                    :key="item.key"
                    @click="navFunc(item,index)">
                    {{item.name}}
                </li>
            </ul>
            <!--导航 end-->
        </div>
    </div>
</template>

<script>
    import {mapGetters,mapActions} from 'vuex';
    export default {
        name: "headPage",
        data(){
            return{
                navList:[
                    {
                        name:'首页',
                        path:'/homePage'
                    },
                    {
                        name:'产品中心',
                        path:'/productCenter'
                    },
                    {
                        name:'关于我们',
                        path:'/aboutMy'
                    },
                    {
                        name:'企业文化',
                        path:'/corporateCulture'
                    },
                    {
                        name:'联系我们',
                        path:'/contactUs'
                    }
                ],
                currentNav:0,
            }
        },
        computed: {
            ...mapGetters(["headIndex"])
        },
        methods:{
            ...mapActions(['headIndexAction']),
            navFunc(item,index){
                this.headIndexAction(index);
                this.$router.push({path:item.path})
            }
        }
    }
</script>

<style scoped lang="scss">
    .head_page {
        width: 100%;
        height: 100px;
        .logo{
            width: 190px;
            height: 48px;
        }
        .nav_class{
            margin-right: 65px;
            padding-bottom: 9px;
            border-bottom: 4px solid #ffffff;
            font-size: 16px;
            line-height: 20px;
            color:#333333;
            cursor: pointer;
        }

        .select_class{
            color:#00A1E9;
            border-color:#00A1E9;
        }
    }
</style>